import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { AuthenticationStateHelperService } from '../../_helpers/authentication-state-helper/authentication-state-helper.service';
import { AuthenticationService } from '../../_services';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'student-view-timeline',
    templateUrl: './student-view-timeline.component.html',
    styleUrls: ['./student-view-timeline.component.css'],
    standalone: false
})
export class StudentViewTimelineComponent implements OnInit {

  public studentId: number;
  public studentName: string;
  public placementId: number = 0;
  public clientId: number = 0;

  constructor(
    public router: Router,
    private featureHelperService: FeatureHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService,
    public dialog: MatDialog,
    private authService: AuthenticationService) {

  }

  ngOnInit(): void {
    if (!this.featureHelperService.hasFeature('Student')) {
      console.error("User does not have the required permissions to view the student landing screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname } });
      this.authenticationStateHelper.unauthorizedToken = true;
    }

    this.studentId = this.authService.userSessionData.currentUser.id;
    this.studentName = this.authService.userSessionData.currentUser.firstName + " " + this.authService.userSessionData.currentUser.lastName;
  }
}
